import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InspectionPdfDownloadService {
  private readonly http = inject(HttpClient);

  // Der Download-Endpoint antwortet auf ein fehlendes S3-Objekt mit 404 (WR-2497); die presigned URL
  // aus dem DTO wuerde in dem Fall das rohe S3-Fehler-XML liefern.
  fetchPdf(inspectionPdfId: string): Observable<Blob> {
    return this.http.post(
      environment.apiUrl + '/api/inspectionPdf/download/' + inspectionPdfId,
      { inspectionPdfId },
      { responseType: 'blob' },
    );
  }

  downloadPdf(fileName: string, inspectionPdfId: string, fileExtension = 'pdf'): Observable<void> {
    return this.fetchPdf(inspectionPdfId).pipe(map(blob => {
      const pdfLink = document.createElement('a');
      pdfLink.href = window.URL.createObjectURL(blob);
      pdfLink.download = fileName + '.' + fileExtension;
      pdfLink.click();
    }));
  }
}
